import { aboutData } from '@/mocks/homeData';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">
          {aboutData.title}
        </h2>
        <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
          {aboutData.description}
        </p>
      </div>
    </section>
  );
}